export default __webpack_public_path__ + "static/media/ncar-modified.f598215d.png";